import React from "react";

const VideoDetails = ({ title, description }) => {
  return (
    <div className="videoDetailsDiv">
      <div className="videoDetailsTitle">{title}</div>
      <div className="videoDetailsDesc">{description}</div>
    </div>
  );
};

export default VideoDetails;
